import React, { useState, useEffect, useRef } from 'react';

import './TabIndex.less';
import '../../../pages/p2p/P2p.less';
import { useParams } from 'react-router-dom';
import WidgetsGrid from '../../_layout/WidgetsGrid';
import useURLSearchParams from '../../../hooks/useURLSearchParams';
import StratIndexBase from './TabIndexSubViews/StratIndexBase';
import StratIndexSpecial from './TabIndexSubViews/StratIndexSpecial';
import StratIndexP2p from './TabIndexSubViews/StratIndexP2p';
import BackBtn from '../../UI/BackBtn';
import UnifiedTable from "./TabIndexSubViews/UnifiedTable";
import UnifiedTableTab from "./TabIndexSubViews/UnifiedTable";

const getWidgetsConfig = (type) => {
  const widgets = [
    { id: 'base', name: 'Целевые показатели эффективности (базовая часть гранта)', show: type !== 'goal' && type !== 'tech' },
    { id: 'special', name: 'Целевые показатели эффективности (специальная часть гранта)', show: type !== 'goal' && type !== 'tech' },
    { id: 'p2p', name: 'Детализация показателя ПРГ2', show: type !== 'goal' && type !== 'tech' },
    { id: 'unified', name: 'Унифицированные показатели', show: true },
  ];

  return widgets.filter(item => item.show);
}

export default function TabIndex(props) {
  const { stratId } = useParams();
  const initializedRef = useRef(false);
  const [activeView, setActiveView] = useState(null);
  const [getViewSearchParam, setViewSearchParam] = useURLSearchParams('view');
  const [hasMultipleWidgets, setHasMultipleWidgets] = useState(true);

  useEffect(() => {
    if (initializedRef.current) return;
    
    const initialViewSearchParam = getViewSearchParam();
    const availableWidgets = getWidgetsConfig(props.data?.type || '');
    
    setHasMultipleWidgets(availableWidgets.length > 1);
    
    if (initialViewSearchParam) {
      setActiveView(initialViewSearchParam);
    } else if (availableWidgets.length === 1) {
      setActiveView(availableWidgets[0].id);
      setTimeout(() => {
        setViewSearchParam(availableWidgets[0].id);
      }, 0);
    }
    
    initializedRef.current = true;
    
    return () => {
      if (getViewSearchParam()) {
        setViewSearchParam(null);
      }
    };
  }, []);

  const changeActiveView = (viewId) => {
    setActiveView(viewId);
    if (viewId === null) {
      setViewSearchParam(null);
    } else {
      setViewSearchParam(viewId);
    }
  };

  const getActiveViewComponent = () => {
    switch (activeView) {
      case 'unified':
        return <UnifiedTableTab/>
      case 'base':
        return <StratIndexBase strategyId={stratId} />;
      case 'special':
        return <StratIndexSpecial strategyId={stratId} />;
      case 'p2p':
        return <StratIndexP2p strategyId={props.data.id} type={props.data.type} />;
      default:
        return <WidgetsGrid items={getWidgetsConfig(props.data?.type || '')} onClick={(item) => changeActiveView(item.id)} cardTextStyle={{ textAlign: 'center' }} />;
    }
  };

  return (
    <div className="tab-index p2p-page">
      {activeView && hasMultipleWidgets && (
        <div style={{ marginBottom: 16 }}>
          <BackBtn onClick={() => changeActiveView(null)} />
        </div>
      )}
      {getActiveViewComponent()}
    </div>
  );
}
